import axios from 'axios'
import store from '@state/store'

export const state = {
  credential: {},
  companyId: '',
}

export const mutations = {
  SET_CURRENT_SESSION_ID(state, newValue) {
    state.credential = newValue
  },
  SET_CURRENT_COMPANY_ID(state, companyId) {
    state.companyId = companyId
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    const credential = state.credential?.Key
    return !!credential
  },
  companyId(state) {
    return state.companyId || ''
  },
  getMsg(state) {
    return state.credential?.Msg
  },
  getKey(state) {
    return state.credential?.Key
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters, state }, { id, pass } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/login', { id, pass, company_id: state.companyId })
      .then((response) => {
        const results = response.data
        commit('SET_CURRENT_SESSION_ID', results)
        return results
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    const Key = store.getters['auth/getKey']
    const companyId = store.getters['auth/companyId']
    commit('SET_CURRENT_SESSION_ID', null)
    return axios.post('/api/logout', {
      Key,
      company_id: companyId,
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.credential) return Promise.resolve(null)
    const key = state.credential?.Key
    const companyId = state.companyId
    return axios
      .post('/api/hashkey', { Key: key, company_id: companyId })
      .then((response) => {
        const results = response.data
        // commit('SET_CURRENT_SESSION_ID', results)
        return results
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_CURRENT_SESSION_ID', null)
        } else {
          console.warn(error)
        }
        return null
      })
  },

  resetCurrentSessionId({ commit }) {
    commit('SET_CURRENT_SESSION_ID', null)
  },
}
